export default __webpack_public_path__ + "static/media/hero-img.140c3b5c.png";